import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    DialogComponent,
    DialogConfiguration,
    DialogService,
    FileexplorerComponent,
    MAT_ICON,
    MetaComponent,
    MetaService,
    TinyMCEHtmlEditorComponent,
    TOAST_STATE,
    ToastmessageService,
    TranslationService
} from '@prekog/common-ui';
import { GetSpecialitiesResponse } from 'src/app/specialitypricelist/getspecialitiesresponse';
import { AppConfigService } from '../../core/config/app-config.service';
import { Speciality } from '../../specialitypricelist/speciality';
import { SpecialityWithChecked } from '../adddoctor/specialitywithchecked';
import { Doctor } from '../doctor';
import { DeleteConsultingHourRequest } from '../models/deleteconsultinghourrequest';
import { DoctorConsultingHour } from './doctorconsultinghour';
import { FindDoctorRequest } from './finddoctorrequest';
import { FindDoctorResponse } from './finddoctorresponse';
import { DeleteJobtitleRequest } from './models/deletejobtitlerequest';
import { DoctorJobTitle } from './models/doctorjobtitle';
import { UpdateDoctorRequest } from './updatedoctorrequest';
import { UploadFileResponse } from './uploadfileresponse';

@Component({
    selector: 'app-updatedoctor',
    templateUrl: './updatedoctor.component.html',
    styleUrls: ['./updatedoctor.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        MatCheckboxModule,
        TinyMCEHtmlEditorComponent,
        FileexplorerComponent,
        MetaComponent
    ]
})
export class UpdatedoctorComponent implements OnInit, AfterViewInit {
    baseRegeneroUrl = '';

    consultingHourForm?: FormGroup;

    deleteConsultingHourUrl = '/admin/delete-consulting-hour';

    deleteContentOfFolderUrl = '/admin/deletefoldercontent';

    deleteJobTitleUrl = '/admin/delete-jobTitle';

    doctor: Doctor = {};

    doctorConsultingHoursList: DoctorConsultingHour[] = [];

    doctorForm?: FormGroup;

    doctorImage = '';

    doctorSpecialityList?: Speciality[];

    downloadFileUrl = '';

    fileBaseUrl = '';

    fileCover: File | null = null;

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;

    findDoctorUrl = '/regenero/find-doctor-by-routerlink';

    formsReady = false;

    getSpecialitiesUrl = '/regenero/get-all-specialities';

    html = '';
    htmlForm?: FormGroup;
    maxFileSize = 5000000;
    originalRouterLink = '';

    regeneroBaseUrl = '';
    specialityWithCheckedList?: SpecialityWithChecked[];
    updateCoverFile = false;
    updateDoctorUrl = '/admin/update-doctor';
    uploadFileToAnExistingFolderUrl = '/admin/updatefile';
    uploadFileUrl = '/admin/uploadFile';
    doctorUrlPrefix = '/doctor';
    private _metaService = inject(MetaService);
    private _route = inject(ActivatedRoute);
    get isFormValid(): boolean {
        const check = {
            doctor: !!this.doctorForm?.valid,
            hours: !!this.consultingHourForm?.valid,
            html: !!this.htmlForm?.valid
        };

        return check.doctor && check.hours && check.html;
    }

    get items() {
        return this.consultingHourForm?.get('items') as FormArray;
    }
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _translateService: TranslationService,
        private cdRef: ChangeDetectorRef
    ) {
        this.downloadFileUrl = _downloadFileUrl;
        this.regeneroBaseUrl = _regeneroBaseUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.baseRegeneroUrl = inject(AppConfigService).config.apiUrlRegenero;
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.createDoctorForm();
            this.createConsultingHourFormArray();
            this.createHtmlForm();
            this.findDoctor();
        }
    }

    createHtmlForm() {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]]
        });
    }

    findDoctor() {
        this.originalRouterLink = this._route.snapshot.paramMap.get('routerLink') as string;
        const findDoctorRequest: FindDoctorRequest = { routerLink: this.originalRouterLink };

        this._apiRequestService
            .sendRequest<FindDoctorRequest, FindDoctorResponse>(this.regeneroBaseUrl, findDoctorRequest, true, this.findDoctorUrl)
            .subscribe((response) => {
                const doctor = response.doctor!;
                this.doctor = doctor;
                this.doctorForm?.patchValue({
                    name: doctor.name,
                    reservationLink: doctor.reservationLink,
                    routerLink: doctor.routerLink
                });

                this.htmlForm?.patchValue({
                    html: doctor.introduction
                });
                const hours = doctor.doctorConsultingHourList || [];
                const hourGroups = hours.map((ch) =>
                    this._fb.group({
                        id: [ch.id],
                        day: [ch.day || '', [Validators.required]],
                        startTime: [ch.startTime],
                        endTime: [ch.endTime],
                        doctorId: [ch.doctorId]
                    })
                );
                this.consultingHourForm?.setControl('items', this._fb.array(hourGroups));

                this.getSpecialities();
                this.formsReady = true;
                this.cdRef.detectChanges();
            });
    }

    openDeleteConsultingDialog(id: number) {
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'consultingHour.deleteConfirmMessage'
        };

        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => this._deleteConsultingHour(id)
        );
    }

    private _deleteConsultingHour(id: number): void {
        const deleteConsultingHourRequest: DeleteConsultingHourRequest = {
            id: id
        };

        this._apiRequestService
            .sendRequest<
                DeleteConsultingHourRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, deleteConsultingHourRequest, true, this.deleteConsultingHourUrl, true)
            .subscribe(() => {
                const indexToRemove = this.items.controls.findIndex((itemControl) => itemControl.get('id')?.value === id);
                if (indexToRemove !== -1) {
                    this.items.removeAt(indexToRemove);
                }
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    createDoctorForm() {
        this.doctorForm = this._fb.group({
            name: ['', [Validators.required]],
            reservationLink: ['', [Validators.required]],
            routerLink: ['', [Validators.required]]
        });
    }

    collectDoctorData() {
        const doctorId = this.doctor.id!;
        this.doctorImage = this.doctor.image!;
        this.doctor = {
            id: doctorId,
            name: this.doctorForm?.controls['name'].value as string | undefined,
            introduction: this.htmlForm?.controls['html'].value as string | undefined,
            reservationLink: this.doctorForm?.controls['reservationLink'].value as string | undefined,
            image: this.doctorImage,
            routerLink: this.doctorForm?.controls['routerLink'].value as string | undefined
        };
    }

    createConsultingHourFormArray() {
        this.consultingHourForm = this._fb.group({
            items: this._fb.array([])
        });
    }

    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.updateCoverFile = false;
    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            this.updateCoverFile = true;
        } else {
            this.updateCoverFile = false;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem ".jpg" vagy ".png"+ kiterjesztésű fájlt töltsön fel!',
                MAT_ICON.warning
            );
            this.dismissError();
        }
    }

    updateDoctor() {
        if (this.fileCover?.size! > this.maxFileSize) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('file.maxSize'),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        }
        this.collectDoctorData();

        const updateDoctorRequest: UpdateDoctorRequest = {
            doctor: this.doctor,
            consultingHourList: this.items.value as DoctorConsultingHour[],
            jobTitleList: this.collectJobTitles()
        };
        const folderName = this.doctor.image!.split('/').pop() as string;
        this._apiRequestService
            .sendRequest<
                UpdateDoctorRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, updateDoctorRequest, true, this.updateDoctorUrl, true)
            .subscribe(() => {
                const routerLinkControl = this.doctorForm?.controls['routerLink'];
                const currentRouterLink = ((routerLinkControl?.value as string) ?? '').trim();
                const newRouterLink = currentRouterLink !== this.originalRouterLink ? currentRouterLink : null;
                const canSaveMeta = this._metaService.canSaveMeta(true);
                if (canSaveMeta || newRouterLink) {
                    this._metaService.saveMetaTag(true, newRouterLink ?? this.originalRouterLink, this.doctor.image!, this.originalRouterLink);
                }
                if (newRouterLink) {
                    this.originalRouterLink = newRouterLink;
                    window.location.href = window.location.href.replace(/[^/]+$/, newRouterLink);
                }
                if (this.fileCover !== null && this.fileCover.size > 0) {
                    this.updateFile(this.fileCover, folderName);
                    this.updateCoverFile = false;
                }
            });
    }

    updateFile(file: File, folderName: string) {
        this._apiRequestService
            .updateFile(file, folderName, true, this.fileBaseUrl, this.uploadFileToAnExistingFolderUrl)
            .subscribe((response) => {
                const uploadFileResponse = response as UploadFileResponse;
                this.doctorImage = uploadFileResponse.downloadUri as string;
                this.doctor.image = uploadFileResponse.downloadUri;
            });
    }

    addConsultationHour() {
        console.log(this.originalRouterLink);
        this._router.navigateByUrl('/addconsultationhour/' + this.originalRouterLink);
    }

    changeJobTitle(specialityWith: SpecialityWithChecked) {
        this.specialityWithCheckedList?.forEach((specialityWithCheck) => {
            if (specialityWith.speciality?.jobTitle === specialityWithCheck.speciality?.jobTitle) {
                specialityWithCheck.checked = !specialityWithCheck.checked;
            }
        });
    }

    getSpecialities() {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitiesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitiesUrl)
            .subscribe((response) => {
                const specilities: Speciality[] = response.specialityList?.filter(
                    (d) => !this.doctor.doctorSpecialityList?.some((d2) => d2.speciality?.jobTitle === d.jobTitle)
                ) as Speciality[];
                const specialityWithCheckedList: SpecialityWithChecked[] = [];
                specilities.forEach((speciality) => {
                    if (!speciality.isSpeciality) {
                        const index = specilities.indexOf(speciality);
                        specilities.splice(index, 1);
                    } else {
                        const specialityWithChecked: SpecialityWithChecked = {
                            speciality: speciality,
                            checked: false
                        };

                        specialityWithCheckedList.push(specialityWithChecked);
                    }
                    this.specialityWithCheckedList = [...specialityWithCheckedList];
                });
            });
    }

    collectJobTitles(): string[] {
        const jobTitleList: string[] = [];

        this.specialityWithCheckedList?.forEach((specialityWithChecked) => {
            if (specialityWithChecked.checked) {
                jobTitleList.push(specialityWithChecked.speciality?.jobTitle!);
            }
        });

        return jobTitleList;
    }

    openDeleteDoctorSpecialityDialog(doctorName: string, jobTitle: string, doctorSpecialityId?: number) {
        const doctorJobtitle: DoctorJobTitle = {
            doctorName: doctorName,
            jobTitle: jobTitle,
            doctorSpecialityId: doctorSpecialityId
        };

        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'jobTitle.deleteConfirmMessage',
            targetData: doctorJobtitle.jobTitle! ?? doctorSpecialityId
        };

        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => this._deleteJobTitle(doctorJobtitle)
        );
    }

    private _deleteJobTitle(doctorJobtitle: DoctorJobTitle): void {
        const deleteJobTitleRequest: DeleteJobtitleRequest = {
            doctorSpecialityId: doctorJobtitle.doctorSpecialityId
        };

        this._apiRequestService
            .sendRequest<
                DeleteJobtitleRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, deleteJobTitleRequest, true, this.deleteJobTitleUrl, true)
            .subscribe(() => {
                this.findDoctor();
            });
    }
}
